<template>
  <div class="col-12 bg-header">
    <div class="container">
      <div class="row">
        <div class="col-12 col-md-2 text-center">
          <a href="https://www.rueden.de/"><img src="https://www.rueden.de/images/Logo-Horizontal-inversion.png" alt="VON RUEDEN"/></a>
        </div>
        <div class="col-12 col-md-8 text-center">
          <h1>{{ title }}</h1>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "rueden-header",
  props: ['title']
}
</script>
